import useSWR from "swr";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";

/**
 * I membri di un gruppo (statico/dinamico) arrivano da un endpoint minimale
 * (user_id, external_id, name, surname) senza status/roles/email/contatori.
 * Questo hook arricchisce i membri visibili in pagina con il dettaglio
 * completo utente (usermgmt/users/:id), la stessa fonte usata da UserDetail,
 * cosi' le card possono mostrare badge stato e ruoli come nella tab Utenti.
 */
export const useGroupMembersDetails = (ids: (string | number)[]) => {
  const key = ids.length ? ["group-members-details", ids.join(",")] : null;

  const { data, isLoading } = useSWR(key, async () => {
    const results = await Promise.allSettled(
      ids.map((id) => fetcher(`${ServicesURL.customer}/${id}`, MethodType.GET)),
    );
    const byId = new Map<string, any>();
    results.forEach((result, index) => {
      if (result.status === "fulfilled") {
        const raw = result.value;
        byId.set(String(ids[index]), raw?.data ?? raw);
      }
    });
    return byId;
  });

  return { detailsById: data ?? new Map<string, any>(), isLoading };
};
